var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGopalBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1168.8 322.9",
    style: {
      enableBackground: "new 0 0 1168.8 322.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\r\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\r\n\t.st3{fill:#B9539F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M189.9,132.5c-12.3,0-22.3,10-22.3,22.3c0,12.3,10,22.3,22.3,22.3h30.7l2.8-44.7H189.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -274.14,
    y1: 596.6582,
    x2: -273.14,
    y2: 596.6582,
    gradientTransform: "matrix(55.854 0 0 -55.854 15479.3711 33480.5508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9539F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    style: {
      stopColor: "#B7539F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3374,
    style: {
      stopColor: "#AF53A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    style: {
      stopColor: "#A153A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#8E54A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7873,
    style: {
      stopColor: "#7654A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9298,
    style: {
      stopColor: "#5353A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A53A4"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.6,
    y: 132.5,
    className: "st0",
    width: 55.9,
    height: 44.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M39.3,60C13.9,85.3,0,119,0,154.8s13.9,69.5,39.3,94.8c25.3,25.3,59,39.3,94.8,39.3 c35.8,0,69.5-13.9,94.8-39.3c23.9-23.9,37.6-55.1,39.1-88.6v-28.5h-47.4v44.7c-9.9,38.5-45,67-86.5,67 c-49.3,0-89.4-40.1-89.4-89.4c0-49.3,40.1-89.4,89.4-89.4c19.3,0,37.7,6.1,53.2,17.5c9.9,7.3,23.9,5.3,31.3-4.6 c7.3-9.9,5.3-23.9-4.6-31.3C190.6,29.9,163,20.8,134,20.8C98.2,20.8,64.6,34.7,39.3,60"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -274.14,
    y1: 596.6582,
    x2: -273.14,
    y2: 596.6582,
    gradientTransform: "matrix(301.8436 0 0 -301.8436 82737.8047 180252.2813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9539F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    style: {
      stopColor: "#B7539F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3266,
    style: {
      stopColor: "#B153A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4382,
    style: {
      stopColor: "#A653A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    style: {
      stopColor: "#9654A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6327,
    style: {
      stopColor: "#8254A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7211,
    style: {
      stopColor: "#6853A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    style: {
      stopColor: "#4253A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8155,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A53A4"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20.8,
    className: "st1",
    width: 268,
    height: 268.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M262.7,60c-15.8,15.8-27.2,34.9-33.5,55.7h47.9c14.5-29.7,45.1-50.3,80.3-50.3c49.3,0,89.4,40.1,89.4,89.4 c0,49.3-40.1,89.4-89.4,89.4c-19.3,0-37.7-6.1-53.2-17.5c-9.9-7.3-23.9-5.3-31.3,4.6c-2.7,3.7-4.2,8-4.4,12.3c0,0,0,0,0,0 c0,0.1,0,0.1,0,0.2c0,0.3,0,0.6,0,1v55.9c0,12.3,10,22.3,22.3,22.3c12.3,0,22.3-10,22.3-22.3v-19.1c14,4.9,28.9,7.4,44.1,7.4 c35.8,0,69.5-13.9,94.8-39.3c25.3-25.3,39.3-59,39.3-94.8S477.6,85.3,452.3,60c-25.3-25.3-59-39.3-94.8-39.3 C321.7,20.8,288,34.7,262.7,60"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -274.14,
    y1: 596.6582,
    x2: -273.14,
    y2: 596.6582,
    gradientTransform: "matrix(0 -302.17 -302.17 0 180652.5781 -82513.9531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9539F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    style: {
      stopColor: "#9154A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6233,
    style: {
      stopColor: "#6853A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    style: {
      stopColor: "#4953A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A53A4"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 229.2,
    y: 20.8,
    className: "st2",
    width: 262.3,
    height: 302.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M645.9,66.4c33.9,0,55.3,16.5,67.8,35.9l-29,15.7c-7.6-11.6-21.6-20.6-38.8-20.6c-29.7,0-51.4,22.9-51.4,53.8 c0,31,21.6,53.8,51.4,53.8c15,0,28.3-6.1,35.4-12.5v-19.9h-43.7v-30h78.2v62.7c-16.7,18.7-40.1,31-69.8,31 c-47.9,0-87.2-33.4-87.2-85C558.7,99.3,598,66.4,645.9,66.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.2,173.5c0-33.7,23.6-62.2,62.7-62.2c39.3,0,62.9,28.5,62.9,62.2c0,33.9-23.6,62.4-62.9,62.4 C753.8,236,730.2,207.4,730.2,173.5 M823.3,173.5c0-18.4-11.1-34.4-30.5-34.4c-19.4,0-30.2,16-30.2,34.4 c0,18.7,10.8,34.7,30.2,34.7C812.3,208.2,823.3,192.2,823.3,173.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.8,69.1h76.7c35.6,0,55.1,24.1,55.1,52.8c0,28.5-19.7,52.3-55.1,52.3h-41.8V233h-34.9V69.1z M941.8,99.1h-37.1v45.2 h37.1c13.8,0,24.1-8.8,24.1-22.6C965.9,108.2,955.6,99.1,941.8,99.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.9,220.7c-8.1,9.6-22.1,15.2-37.6,15.2c-18.9,0-41.3-12.8-41.3-39.3c0-27.8,22.4-37.8,41.3-37.8 c15.7,0,29.7,4.9,37.6,14.5v-16.5c0-12-10.3-19.9-26.1-19.9c-12.8,0-24.6,4.7-34.7,14l-11.8-20.9c14.5-12.8,33.2-18.7,51.9-18.7 c27,0,51.9,10.8,51.9,45V233h-31.2V220.7z M1078.9,189.8c-5.2-6.9-15-10.3-25.1-10.3c-12.3,0-22.4,6.6-22.4,17.9 c0,11.1,10.1,17.4,22.4,17.4c10.1,0,19.9-3.4,25.1-10.3V189.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1121.4,
    y: 69.1,
    width: 31.2,
    height: 163.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M744.7,99.3c-3.5,0-7-1.8-8.9-5.1c-2.8-4.9-1.2-11.2,3.7-14c31.4-18.2,70.5-18.3,102-0.2 c4.9,2.8,6.6,9.1,3.8,14c-2.8,4.9-9.1,6.6-14,3.8c-25.2-14.4-56.5-14.3-81.6,0.2C748.2,98.8,746.4,99.3,744.7,99.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M724.3,63.9c-3.5,0-7-1.8-8.9-5.1c-2.8-4.9-1.2-11.2,3.7-14c44.2-25.5,99.1-25.5,143.2,0 c4.9,2.8,6.6,9.1,3.7,14c-2.8,4.9-9.1,6.6-14,3.7c-37.9-21.9-84.9-21.9-122.7,0C727.8,63.5,726,63.9,724.3,63.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGopalBrand);
export default __webpack_public_path__ + "static/media/gopal-brand.de12843314d3053d3d4f796f4956ba94.svg";
export { ForwardRef as ReactComponent };